// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1lzrT","disabled":"FileBtn_disabled__3hZJ-","warn":"FileBtn_warn__3PGgc","fade":"FileBtn_fade__1UfOI"};